import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.less']
})
export class BaseEditComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
